export default __webpack_public_path__ + "static/media/ava.a917a2e2.png";